import Analytics from './analytics';
import initGtmEvents from './gtm-events';

export default function init() {
	new Analytics();
	initGtmEvents();
}